export default "__VITE_ASSET__YGWe_gmx__"